import { Action } from '@ngrx/store';
import { PreferenceGroup } from '@store/user/user.model';
import { UserPreferences } from '@store/settings/settings.model';

export const RESTORE_DEFAULT_PREFERENCE = '[PREFERENCES] RESTORE_DEFAULT_PREFERENCE';
export const SAVE_CHANGES_USER_PREFERENCE = '[PREFERENCES] SAVE_CHANGES_USER_PREFERENCE';
export const GET_USER_PREFERENCES = '[PREFERENCES]GET_USER_PREFERENCES';
export const GET_USER_PREFERENCES_SUCCESS = '[PREFERENCES]GET_USER_PREFERENCES_SUCCESS';

export class RestoreDefaultPreference implements Action {
  readonly type = RESTORE_DEFAULT_PREFERENCE;
}

export class SaveChangesUserPreference implements Action {
  readonly type = SAVE_CHANGES_USER_PREFERENCE;
  constructor(public payload: {preferenceGroups: Array<PreferenceGroup>, userPreferences: Array<UserPreferences>}) {}
}

export class GetUserPreferences implements Action {
  readonly type = GET_USER_PREFERENCES;
}

export class GetUserPreferencesSuccess implements Action {
  readonly type = GET_USER_PREFERENCES_SUCCESS;
  constructor(public payload: Array<UserPreferences>) {}
}


export type All =
  RestoreDefaultPreference |
  SaveChangesUserPreference |
  GetUserPreferences |
  GetUserPreferencesSuccess;
